












import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ProfileItem extends Vue {
    @Prop() public icon: string;

    @Prop() public title: string;

    @Prop() public description: string ;
}
